<div class="d-flex justify-content-between">
  <h4 class="mb-2 text-uppercase">Historique des services</h4>

  <span class="text-black-50 fw-bold fst-italic">
    <i-feather name="Info" class="info-icon"></i-feather>
    <span class="info-text">
      Accédez à vos résultats gratuitement pendant
      <span class="text-secondary">12 mois</span>
    </span>
  </span>
</div>

<div *ngIf="isLoading" class="text-center mt-4">
  <p-loader size="large"></p-loader>
</div>

<div *ngIf="!isLoading">
  <app-historique-service-search-form
    class="mb-4"
    (searched)="onSearch($event)"
  ></app-historique-service-search-form>

  <app-historique-services-table
    [serviceHistory]="serviceHistory"
    [limit]="limit"
    [canAccessReport]="isUserCanAccessReport"
    [canDownloadReport]="isUserCanDownloadReport"
    [canEditReport]="isUserCanEditReport"
    (pageChanged)="onPageChange($event)"
    (sortChanged)="onSortChanged($event)"
  ></app-historique-services-table>
</div>
